import React from 'react'
import  node from '../../assets/img/node.PNG';
import socketio from '../../assets/img/socketio.PNG';
import vuex from '../../assets/img/vuex.PNG';
import redux from '../../assets/img/redux.PNG';
import flutter from '../../assets/img/flutter.PNG';
import scrap from '../../assets/img/scrap.PNG';
import mongo from '../../assets/img/mongo.PNG';
import {Slide} from 'react-awesome-reveal';
import {Button} from '@material-ui/core';

export default function Codes(){
    return (
       <div style={{ width:"100vw" }}>
       <div className="code">
       <div>
       <Slide cascade direction='left'>
       <img width="70%" src={node} />
       </Slide>
       Node js code with Joi library
       </div>
       <div>
       <Slide cascade direction='left'>
       <img width="70%" src={mongo} />
       </Slide>
       MogoDB Model using Mongoose
       </div>
       <div>
       <Slide cascade direction='left'>
       <img width="100%" src={scrap} />
       </Slide>
       puppeteer scrap bot
       </div>
       <div>
       <Slide cascade direction='left'>
       <img width="100%" src={flutter} />
       </Slide>
       flutter mobile design code
       </div>
       <div>
       <Slide cascade direction='left'>
       <img width="60%" src={vuex} />
       </Slide>
       vuex state managment with vuejs
       </div>
       <div>
       <Slide cascade direction='left'>
       <img width="100%" src={socketio} />
       </Slide>
       Real time data rcieved with Socket.IO
       </div>
       <div>
       <Slide cascade direction='left'>
       <img width="70%" src={redux} />
       </Slide>
       Redux store for state managment with ReactJs
       </div>
     </div>
     <div  className="btn-showmore">
     <Slide cascade direction='left'>
     <Button color="primary" variant="contained" href="https://github.com/azizmobarak">See More in Github</Button>
     </Slide>
     </div>
       </div>
      )
}
